export default __webpack_public_path__ + "static/media/shravana.acf6b4c7.jpg";